<script setup lang="js">
import { computed, markRaw, onMounted, onUnmounted, provide, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useRouteParams } from '@vueuse/router';
import { storeToRefs } from 'pinia';
import _ from 'lodash';

import { useAutotableStore } from '@/stores/autotable.store';
import { useInputFieldStore } from '@/stores/inputField.store';

import AutoEntityVariables from '@/components/AutoEntities/Variables.vue';
import AutoEntityOperations from '@/components/AutoEntities/Operations.vue';
import AutoEntityOutputs from '@/components/AutoEntities/Outputs.vue';

const tabs = [
  {
    id: 'variables',
    title: 'Переменные',
    component: markRaw(AutoEntityVariables)
  },
  {
    id: 'operations',
    title: 'Операции',
    component: markRaw(AutoEntityOperations)
  },
  {
    id: 'outputs',
    title: 'Выходные данные',
    component: markRaw(AutoEntityOutputs)
  }
];

const autoStore = useAutotableStore();
const inputFieldStore = useInputFieldStore();

provide('autoStore', autoStore);

const { updateAutotableRequest, getAutotableRequest } = storeToRefs(autoStore);
const { inputField } = storeToRefs(inputFieldStore);

const projectId = useRouteParams('projectId');
const bpId = useRouteParams('bpId');
const nodeId = useRouteParams('nodeId');
const inputTableId = useRouteParams('inputTableId');
const router = useRouter();
const activeTab = ref(tabs[0]);

const updateErrors = computed(() => {
  if (_.isString(updateAutotableRequest.value.error)) {
    return [updateAutotableRequest.value.error];
  }

  return updateAutotableRequest.value.error?.errors || {};
});
const tableName = computed(() => {
  const ruTitle = inputField.value?.the_table?.title?.['ru'];
  const firstTitle = Object.values(inputField.value?.the_table?.title || {})[0];
  return ruTitle || firstTitle || '';
});

onMounted(() => {
  const inputTableArgs = [
    projectId.value,
    bpId.value,
    nodeId.value,
    inputTableId.value
  ];

  autoStore.getAutotable(...inputTableArgs);
  inputFieldStore.getInputTable(...inputTableArgs);
});

onUnmounted(() => {
  autoStore.$reset();
});

function updateAutonode() {
  autoStore
    .updateAutotable(
      projectId.value,
      bpId.value,
      nodeId.value,
      inputTableId.value
    )
    .then(() => router.push({ name: 'input-fields' }));
}
</script>
<template>
  <div class="container-fluid">
    <div class="page-header d-flex mt-3 align-items-center">
      <RouterLink
        :to="{
          name: 'input-fields',
          params: {
            projectId: projectId,
            bpId: bpId,
            nodeId: nodeId
          }
        }"
        class="back-btn"
      />
      <h1 class="mb-0">Автотаблица таблицы "{{ tableName }}"</h1>
    </div>
  </div>
  <div class="autoform-page d-flex">
    <div class="autoform_sidebar">
      <div
        v-for="(tab, index) in tabs"
        :key="tab.id"
        class="bp-section-content_link"
        :class="{ 'router-link-active': activeTab.id === tab.id }"
        @click="activeTab = tab"
      >
        {{ index + 1 }}. {{ tab.title }}
      </div>

      <div class="px-3 mt-3">
        <button
          class="orange-btn w-100"
          @click="updateAutonode()"
          :disabled="updateAutotableRequest.isLoading"
        >
          Сохранить
        </button>
      </div>
      <p v-if="updateErrors" class="error-mesage">
        <span class="d-block" v-for="error, key in updateErrors" :key="key">
          {{ error.length ? error[0] : error }}
        </span>
      </p>
    </div>
    <div
      class="autoform_content"
      :class="{ 'gray-bg': activeTab.id === 'operations' }"
      v-if="getAutotableRequest.data"
    >
      <component :is="activeTab.component" />
    </div>
  </div>
</template>
